/* eslint-disable */
import axios from "axios";
const state = {
    user: null,
    isLoggedIn: false,  
};
const getters = {
    isLoggedIn (state){
        return state.isLoggedIn
    },
    user (state) {
        return state.user
    }
};
  
const actions = {
    async postLogin({ commit }, data) {
        return new Promise((resolve, reject) => { 
          axios.post('/api/public/login/siswa', data)
            .then(response => {
                if(response.data.code === '200') {
                    const token = response.data.key;
                    commit('set_user', response.data.records)
                    localStorage.setItem('token', token);
                    localStorage.setItem('setusers', JSON.stringify(response.data.records));
                /*  dispatch('get_user') */
                }
                resolve(response)
                
            })
            .catch(err => {
                commit('reset_user')  
                localStorage.removeItem('token')
                localStorage.removeItem('setusers')
                reject(err)
            })
        })
    },
    async LogOut({ commit }) {
        let data = null;
        commit("reset_user", data);
    },
    async get_user({commit}){ 
        if(!localStorage.getItem('token')){
          return
        }
        try{ 
          let response = await axios.get('/api/public/auth/siswa')
            commit('set_user', response.data.data)
        } catch (error){
            commit('reset_user')
            localStorage.removeItem('token')
            localStorage.removeItem('setusers')
            return error
        } 
    }
};
const mutations = {
    set_user (state, data) {
        state.user = data
        state.isLoggedIn = true
    }, 
    reset_user (state) {
        state.user = null
        state.isLoggedIn = false
        localStorage.removeItem('token')
        localStorage.removeItem('setusers')
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};